/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Upload_CoverInputs */

const cs_blog_upload_cover = /** @type {(inputs: Blog_Upload_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrát obrázek`)
};

const en_blog_upload_cover = /** @type {(inputs: Blog_Upload_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload cover`)
};

/**
* | output |
* | --- |
* | "Upload cover" |
*
* @param {Blog_Upload_CoverInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_upload_cover = /** @type {((inputs?: Blog_Upload_CoverInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Upload_CoverInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_upload_cover(inputs)
	return cs_blog_upload_cover(inputs)
});